export const GenerateCrewListModal: string = 'GenerateCrewListModal';
